import { render } from "./StatisticCascadeRating.vue?vue&type=template&id=695ed8bf&ts=true"
import script from "./StatisticCascadeRating.vue?vue&type=script&lang=ts"
export * from "./StatisticCascadeRating.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__